// Bug fix: this ran on every single scroll event, unthrottled, and read .scrollHeight each time -
// forcing the browser to flush layout synchronously on every tick. On a PLP with a large DOM
// (e.g. after infinite scroll has loaded many products), that's a significant forced-reflow cost
// repeated dozens of times per second during a scroll fling. Throttled to one measurement per
// animation frame, which is all this needs.
let scrollTicking = false;
window.onscroll = function () {
  if (scrollTicking) return;
  scrollTicking = true;

  requestAnimationFrame(() => {
    const headerEl = document.querySelector(".collection-image-with-title");
    const loopEl = document.querySelector("#CollectionLoop");
    const popoutGroup = document.querySelector(".popout--group");

    if (headerEl && loopEl && popoutGroup) {
      const headerHeight = headerEl.offsetHeight + 40;
      const inRange = window.scrollY >= headerHeight && window.scrollY < loopEl.scrollHeight;
      popoutGroup.classList.toggle("fixed-header", inRange);
    }

    scrollTicking = false;
  });
};


const filterButton = document.querySelector(".popout__toggle--filters");
const collectionProducts = document.querySelector(".collection__products");

// Bug fix: filterButton is a static, persistent element (not replaced when the grid re-renders),
// but the click listener below was being re-added every time the grid mutated (every "Show More"
// click, every filter change) with no removal - the same unbounded listener-duplication bug found
// and fixed elsewhere in Collection/CartDrawer. Bound once, outside the observer callback.
if (filterButton) {
  filterButton.addEventListener("click", () => {
    setTimeout(() => {
      const filterSidebar = collectionProducts && collectionProducts.querySelector('#filter-groups');
      const collectionList = collectionProducts && collectionProducts.querySelector("#CollectionLoop");
      filterSidebarClassList(filterSidebar, collectionList);
    }, 50);
  });
}

if (collectionProducts) {
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === 'childList') {
        const collectionList = collectionProducts.querySelector("#CollectionLoop");
        const filterSidebar = collectionProducts.querySelector('#filter-groups');
        filterSidebarClassList(filterSidebar, collectionList);
      }
    });
  });

  observer.observe(collectionProducts, { childList: true, subtree: true });
}

function filterSidebarClassList(filter, collection) {
  if(filter && filter.classList.contains("expanded")) {
    collection.classList.add('product-grid-3');
  }else{
    collection.classList.remove('product-grid-3');

  }
}
